<!-- 1001：客户登记 -->
<template>
     
    <el-card class="newtable"  style="width:96%;margin-left:auto;margin-right:auto">
        
        <div slot="header" class="clearfix">
            <span> 寄件申请 </span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
            <el-button type='text' style="float: right; padding: 3px 0;color:black" >填表日期： {{form.createDate}}</el-button>
        </div>
    

        <el-form ref="form" :model="form" label-width="150px" class="formtable">
            <!-- <el-col :span="24"   >
                <div class="tag_item"  >客户信息 </div>
            </el-col> -->


            <el-form-item label="寄件人">
                <el-col :span="23"  >
                    <!-- <el-input :readonly="isReadOnly"  v-model="form.seal_filename"></el-input> -->
                   <!-- {{ $store.state.companyInfo.name}} -->
                    <span  v-if="mode=='new'">  {{ $store.state.userInfo.name}} </span>
                    <el-input v-else  readonly    v-model="form.applier.realname"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="*收件人">
                <el-col :span="10"  >
                    <el-input :readonly="isReadOnly"  v-model="form.who_got"></el-input>
                    <!-- <el-select v-model="form.file_type" placeholder="请选择"  style="width:100%"  @change="ChangeFileType"  >
                        <el-option
                            v-for="item in fileType"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select> -->
                </el-col>


               <el-col class="line" :span="3"  >  *收件电话 </el-col>

                <el-col :span="10"   >
                    <el-input :readonly="isReadOnly"  v-model="form.receive_phone"></el-input>
                    <!-- <el-select v-model="form.seal_type" placeholder="请选择"  style="width:100%" >
                        <el-option
                            v-for="item in sealType"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select> -->
                </el-col>

               
                
            </el-form-item>


 


            <el-form-item label="*收件地址">
                <el-col :span="24">
                    <el-input :readonly="isReadOnly"  v-model="form.receive_address"></el-input>
                
                </el-col> 
            </el-form-item>


            <el-form-item label="*寄件类型 ">
                <el-col :span="10">
                    <!-- <el-switch :disabled="mode!='new' && mode!='edit' && mode!='rewrite'"  v-model="form.is_opposite_seal"></el-switch> -->
                    <el-select v-model="form.send_type" :disabled="isReadOnly" placeholder="请选择"  style="width:100%" >
                        <el-option
                            label="对公快递"
                            value="business">
                        </el-option>
                        <el-option
                            label="私人快递"
                            value="personal">
                        </el-option>
                    </el-select>
                
                </el-col> 
            </el-form-item>
       

          

            <!-- <el-divider content-position="center">备注</el-divider> -->

            <!-- <el-col :span="24"   >
                <div class="tag_item"  >备注 </div>
            </el-col> -->

            <el-form-item label="备注信息">
                <!-- <el-input v-model="form.remarks"></el-input> -->
                <el-col :span="23" >
                <el-input
                    type="textarea"
                    :readonly="isReadOnly"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="form.remarks">
                </el-input>
                </el-col>
            </el-form-item>

            <el-form-item v-if="this.mode=='new' || this.mode=='edit' || this.mode=='rewrite'">
                <el-col :span="11" >
                    <el-button type="primary" @click="NewFormSubmit" style="margin:auto;width:150px">提交</el-button>
                    <!-- <el-button style="margin:auto">取消</el-button> -->
                </el-col>

                <el-col :span="11" >
                    <!-- <el-button type="primary" @click="onSubmit" style="margin:auto">立即创建</el-button> -->
                    <el-button style="margin:auto;width:150px" @click="CancelForm" >取消</el-button>
                </el-col>


            </el-form-item>  

    



        
        </el-form>


    

    </el-card>

</template>

<script>
    function getNum() {
        var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
            'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
            'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
            'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
            'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
            'x', 'y', 'z'];
        var nums = "";
        for (var i = 0; i < 8; i++) {
            var id = parseInt(Math.random() * 61);
            nums += chars[id];
        }
        return nums;
    }

    import affix_box from '@/components/oa/functions/affix_box.vue'



	export default {
        name: 'template_1001',
        props: {
            form:Object,
            mode:String,
        },
        components: { 
            affix_box
        },
        data() {
			return {
                isReadOnly:false,

                fileType:['法律服务合同','程序性文件','律师函','法律意见书','投标文件','其他'],
                sealType:['律所公章','合同文书章'],
                
                file_list:[],
                uploadData:{
                    'whattodo':"upLoadFiles"
                },
                dialogImageUrl:'',
                dialogVisible:false,
			}
        },
        mounted() {
        

            let t=setInterval(()=>{
                if(this.mode){
                    clearInterval(t)
                    if(this.mode!='new' && this.mode!='edit' && this.mode!='rewrite'){
                        this.isReadOnly=true
                    }

                 


                    if(this.mode=='rewrite' && this.form.fileList && this.form.fileList.length>0){

                        this.file_list=this.form.fileList 
                        console.log('=======================this.file_list:',this.file_list)

                        
                    }

                }


            },500)
             


            // this.screenWidth = document.body.clientWidth;
            // this.screenHeight = document.body.clientHeight;
            // window.onresize = () => {
            //     return (() => {
            //         window.console.log('document.body.clientWidth:',document.body.clientWidth)
            //         window.console.log('document.body.clientHeight:',document.body.clientHeight)
                   
            //         this.screenWidth = document.body.clientWidth;
            //         this.screenHeight = document.body.clientHeight;
            //         if (document.body.clientWidth<=1100){
            //             this.rightOnShow=false
            //         }else{
            //              this.rightOnShow=true
            //         }

            //     })();
            // };
        },
        methods: {

            NewFormSubmit(){
                let obj={"template_id":"mail" , "sheet_name":"寄件申请表" }
                // console.log('1001 NewFormSubmit emit')
                this.$emit('SubmitNewForm',obj); 
            },
           CancelForm(){
                window.close();

            },


            handlePictureCardPreview(file) {
                console.log("handlePictureCardPreview file:",file)
                this.dialogImageUrl = file.url || file.fileLink ;
                this.dialogVisible = true;
            },



            handleUploadbefore(file){
             
                console.log("handleUploadbefore start file:",file)
                const fileType = file.type  ;
                const isLt50M = file.size < 50*1024*1024 ;
                if (!isLt50M){
                    this.$message.error('上传文件大小不能超过50MB!');
                }
                // if(!fileType){
                //   this.$message.error('不能上传目录!');
                // }


                window.console.log(isLt50M)
                if(isLt50M ){
                    // this.uploadData={
            //   'id':guid2(),
            //   'whattodo':"upLoadFiles",
            //   'articleId':this.article.docid
            // }
                this.uploadData.name=file.name
                this.uploadData.flow_id=this.form.flow_id
                 
                // window.console.log('this.uploadData:',this.uploadData)
                this.uploadData.whattodo="upLoadFiles"
                // this.uploadData.articleId=this.article.docid
                // this.uploadData.id=file.uid
                return isLt50M;
                }else{
                return false
                }

            },

            ChangeFileType(a){
                console.log('a:',a)
                this.form.seallist=[a]

            },
            DeleteFromFileList(obj){
                this.$emit('DeleteFromFileList',obj); 
            },
            DeleteFromFileList2(file){
                let id=file.response.id
                console.log('this.form.fileList:',this.form.fileList)
            
                console.log('id:',id)
                var ind=this.form.fileList.findIndex((value)=>value.id==id);

                // var ind=this.form.fileList.find((value,index,arr)=>{
                //     if(value.id==id){
                //         return index
                //     }
                // });

                console.log('ind:',ind)
                if(ind!=-1){
                    this.form.fileList.splice(ind,1)
                }
            },


            handleUploadSuccess(res, file){
                // let a = URL.createObjectURL(file.raw);
                window.console.log('upload success res: ',res)

                
                // window.console.log('file_list:',this.file_list)
                window.console.log('upload success file: ',file)
                if (res.status=='ok'){
                    let obj={
                    "name":res.fileName,
                    'fileName':res.fileName,
                    'fileLink':res.fileLink,
                    'lastModified':file.raw.lastModified,
                    'id':res.id,
                    // "url":file.url
                    }
                    window.console.log('obj: ',obj)
                    // this.article.files.push(obj)
                    // this.Add2FileList(obj)
                    this.form.fileList.push(obj)

                    // this.file_list.push(obj)

                    console.log("file_list:",this.file_list)
                    console.log(" this.form.fileLis:", this.form.fileList)
                    // this.form.fileList=this.fileList



                }else if(res.status=='fail'){
                    if(res.errCode==4005){
                        this.$message({
                            type: 'info',
                            message: '不能上传超过5个文件噢'
                        }); 
                    }else if(res.errCode==4002){
                        this.$message({
                            type: 'info',
                            message: '文件大小合计不能超过5M'
                        }); 
                    }else if(res.errCode==4001){
                        this.$message({
                            type: 'info',
                            message: '文件为空'
                        }); 
                    }

                }
            


            },



        
            CheckFile(item){
               
                this.dialogImageUrl = item.tempLink ;
                this.dialogVisible = true;

                // window.open(item.tempLink)


            },





            handleDownload(file) {
                console.log(file);
            },
            

      
            handleRemove(file) {
                console.log('handleRemove ++++++++++',file);


                var that=this
                var datas= { 
                    fileLink:file.response.fileLink,
                    whattodo: "delete_file",
                    fileName:file.response.fileName,
                    // flow_id:this.form.flow_id
                }
                this.axios.post(this.$root.rootUrl+'oa',datas
                ).then(function (res) {
                    window.console.log(res)

                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else if (result.status=='ok'){

                            that.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            that.DeleteFromFileList(file)
                            that.DeleteFromFileList2(file)

                            let id=file.response.id

                            // console.log('id:',id)
                            console.log('that.form.fileList:',that.form.fileList)
                            
                            console.log("this.$refs.upload.fileList:",that.$refs.upload.fileList)

                            let fileList=that.$refs.upload.fileList
                            let ind1=fileList.findIndex((value)=>value.response.id==id);
                            console.log("++++++++++++ind1:",ind1)
                            if(ind1!=-1){
                                that.$refs.upload.fileList.splice(ind1,1)
                            }


             

 
                        } else if (result.status=='fail'){
                            that.$message('删除失败');
                            
                        }


                        
                    }

                    
                }).catch(function (error) {
                    window.console.log(error);
                    // that.saving_sig=0
                });




            },



            handleChange(file, fileList) {
                console.log('handleChange   file:',file,"fileList:",fileList)
                this.file_list=fileList

                // console.log(t)
                console.log('this.$refs.upload',this.$refs.upload)

                // this.$refs.upload.fileList=fileList
            }



          


             

        }
	}
	
</script>

<style>
/* .el-menu{
    color:black;
} */

 
 

</style>
